import { createContext, useContext } from "react"

/** If true, the page is in a preview mode */
export const PreviewModeContext = createContext(false)

export function useIsPreviewMode() {
  return useContext(PreviewModeContext)
}
